/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */

import moment from 'moment';
import React, {
    useState, useCallback, useRef, useEffect,
} from 'react';
import { Calendar } from 'react-calendar';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { createUrl } from '../../../redux/helper/CreateQuery';
import { removeLastComma } from '../../../redux/helper/RemoveComma';

export default function Filters({
    close, setFilter, Filter, handleFetch, setfilterUrl, selected, setselected,
}) {
    const dateRef = useRef();
    const order_Status = {
        Draft: 0,
        Pending: 1,
        InProcess: 2,
        'ApprovedOut for delivery': 3,
        'Partially delivered': 4,
        Deliverd: 5,
        Completed: 6,
        Cancelled: 7,
    };

    // const order_status = {
    //     0: 'Draft',
    //     1: 'Pending',
    //     2: 'InProcess',
    //     3: 'Approved',
    //     4: 'Out for delivery',
    //     5: 'Partially Delivered',
    //     6: 'Deliverd',
    //     7: 'Completed',
    //     8: 'Rejected',
    // };
    const [selectedType, setselectedType] = useState('order_type');
    const getObjectUrl = () => {
        let final = '';
        Filter.order_status.length > 0 && Filter.order_status.map((val) => {
            final += `${val},`;
        });
        return removeLastComma(final);
    };
    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_type':
                if (Filter[key].length !== 0) { final += `&order_type=${createUrl(Filter[key])}`; }

                break;
                // case 'order_status':
                //     if (Filter[key].length !== 0) {
                //         final += `&status=${getObjectUrl()}`;
                //     }
                //     break;
            case 'payment_type':
                if (selected.start_date !== '' && selected.end_date !== '') {
                    final += `&created_range=${moment(selected.start_date).format('DD/MM/YYYY')},${moment(selected.end_date).format('DD/MM/YYYY')}`;
                }
                break;
            default: break;
            }
        });
        handleFetch(final);
        setfilterUrl(final);
        return final;
    };

    const handleClear = () => {
        setFilter({
            order_type: [],
            order_status: [],
            payment_type: [],
        });
        setselected({ start_date: '', end_date: '' });
        setfilterUrl('');
        handleFetch();
    };
    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const currentDate = moment(new Date()).format('YYYY/MM/DD');
    const ref = useRef();
    const ref1 = useRef();
    const [toggle, settoggle] = useState(toggleState);
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                if (selected === '') {
                    settoggle((prevState) => ({
                        ...prevState,
                        start_date: false,
                        end_date: false,
                    }));
                }
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    const AddToSelect = (item, type) => {
        const arr = [...selected[type]];
        const index = arr.indexOf(item);
        if (index === -1) {
            arr.push(item);
        } else {
            arr.splice(index, 1);
        }
        setselected((prevState) => ({
            ...prevState,
            [type]: arr,
        }));
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };
    return (
        <div
            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
        >
            <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                    Filter
                </h5>
                <img
                    className="p-2 rounded-full cursor-pointer absolute top-4 right-4"
                    src="/images/Component158–2.svg"
                    alt="close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => close(false)}
                />
            </div>
            <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                <div className="flex items-start">
                    <ul className="nav nav-pills flex active flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                        <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselectedType('order_type')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'order_type' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-priceranje"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-pricetab"
                                role="tab"
                                aria-controls="pills-price"
                                aria-selected="true"
                                data-testid="type-order"
                            >
                                Order Type
                            </a>
                        </li>
                        <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('payment_type')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'payment_type' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-categories"
                                data-bs-toggle="pill"
                                data-bs-target="#pillcategorie"
                                role="tab"
                                aria-controls="pillcategorie"
                                aria-selected="false"
                            >
                                Date Range
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content w-[70%] h-[450px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                        <div className={`tab-pane fade ${selectedType === 'order_type' ? 'show active' : ''} px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                            <div className="relative">
                                <div className="cursor-pointer">
                                    {['Trade', 'Trade EUB', 'Domestic', 'Free Service', 'Demo', 'Free Samples', 'Free Replacement', 'Service', 'Repair', 'Free Supplies'].map((orderType, orderInd) => (
                                        <div
                                            key={`order${orderInd}`}
                                            className="relative flex items-center mb-3"
                                            onClick={() => HandleFilter('order_type', orderType)}
                                        >
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes(orderType) ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.order_type?.includes(orderType)}
                                                borderColor={`${Filter.order_type?.includes(orderType) ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                            />
                                            <label data-testid={orderType.toLowerCase().replace(/\s+/g, '-')} htmlFor={`order${orderInd}`} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                {orderType}
                                                {' '}
                                                Order
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${selectedType === 'order_status' ? 'show active' : ''}`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                            <div className="ml-5 cursor-pointer">
                                {Object.keys(order_Status).map((val, i) => (
                                    <div key={i} className="relative flex items-center">
                                        <Checkbox
                                            icon={
                                                <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_status?.includes(order_Status[val]) ? '#555259' : ''}` }} />
                                            }
                                            name="my-input"
                                            className="cursor-pointer"
                                            checked={Filter.order_status.includes(order_Status[val])}
                                            onChange={() => HandleFilter('order_status', order_Status[val])}
                                            borderColor={`${Filter.order_status.includes(order_Status[val]) ? '#B8C5DC' : '#555259'}`}
                                            style={{ cursor: 'pointer' }}
                                            labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                        />
                                        <label htmlFor={`id-${i + 1}`} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{val}</label>
                                    </div>
                                ))}

                            </div>
                        </div>
                        <div className={`tab-pane fade ${selectedType === 'payment_type' ? 'show active px-3' : 'px-3 '}`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                            <div
                                className="mt-[18px] pb-10"
                                ref={dateRef}
                            >
                                <div className="flex items-center mt-3">
                                    <div
                                        className="relative w-1/2"
                                        onClick={() => handleToggle('start_date')}
                                    >
                                        <label />
                                        <img
                                            src="images/Iconawesome-calendar-alt.svg"
                                            onClick={() => handleToggle('start_date')}
                                            alt="icon"
                                            className="absolute top-3 right-2.5 cursor-pointer"
                                        />
                                        <input
                                            datepicker
                                            datepicker-autohide
                                            value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                .join('/')}
                                            type="text"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                            placeholder="Date From"
                                        />

                                    </div>
                                    {toggle.start_date && (
                                        <Calendar
                                            value={moment(selected.start_date).format('YYYY/MM/DD').start_date}
                                            onChange={(val) => handleDate(val, 'start_date')}
                                            placeholder="Date from"
                                            className="absolute top-[80px] right-[70px]"
                                        />
                                    )}

                                    <p className="text-base font-normal text-[#555259] px-2.5 pb-50">to</p>
                                    <div
                                        className="relative w-1/2"
                                        onClick={() => handleToggle('end_date')}
                                    >
                                        <label />
                                        <img
                                            src="images/Iconawesome-calendar-alt.svg"
                                            onClick={() => handleToggle('end_date')}
                                            alt="icon"
                                            className="absolute top-3 right-2.5 cursor-pointer"
                                        />
                                        <input
                                            value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                .join('/')}
                                            datepicker
                                            datepicker-autohide
                                            type="text"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                            placeholder="Date To"
                                        />

                                    </div>
                                    {toggle.end_date && <Calendar value={selected.end_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selected.start_date).toDate()} placeholder="Date to" className="absolute top-[80px] right-[70px]" />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full">
                    <div className="pt-3 flex justify-end w-[30%] mr-5">
                        <button
                            onClick={() => handleClear()}
                            type="button"
                            className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            Clear Filter
                        </button>
                    </div>
                    <div className="pt-3 flex justify-end w-[70%]">
                        <button
                            disabled={selected.start_date !== '' && selected.end_date === ''}
                            onClick={() => generateUrl()}
                            type="button"
                            className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            data-testid="apply-btn"
                        >
                            Apply Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
